<template>
  <v-app>
    <v-main class="py-0">
      <div class="con_side">
        <v-row justify="center" class="col-12 mb-5 rounded-lg">
          <v-col
            justify="center"
            class="col-12 pl-md-15 pl-xs-6 pl-8 text-center"
          >
            <template>
              <v-btn block disabled x-large class="my-5">
                <h3
                  class="font-weight-bold my-4"
                  :style="`color:${$vuetify.theme.dark ? 'white' : 'black'}`"
                >
                  委託表單
                </h3>
              </v-btn>
            </template>
            <!-- <br> -->
            <v-row justify="center" class="my-3">
              <a href="https://forms.gle/k4mZhJgQ9oUuQkrCA" target="_blank">
                <v-btn color="primary" elevation="2" class="mx-3">
                  委託表單
                </v-btn>
              </a>
            </v-row>
          </v-col>

          <v-col justify="center" class="col-12 pl-md-15 pl-xs-6 pl-8">
            <template>
              <v-btn block disabled x-large class="my-5">
                <h3
                  class="font-weight-bold my-4"
                  :style="`color:${$vuetify.theme.dark ? 'white' : 'black'}`"
                >
                  委託規則
                </h3>
              </v-btn>
            </template>

            <p class="my-3" v-html="rule" style="line-height: 4ch"></p>

          </v-col>
        </v-row>
      </div>
    </v-main>
  </v-app>
</template>

<style scoped>
.con_side {
  max-width: 60%;
  margin-right: auto;
  margin-left: auto;
}

@media (max-width: 720px) {
  .con_side {
    max-width: 100%;
  }
}
</style>

<script>
export default {
  data: () => ({
    rule: "接受委託且確認。開始製作後，有免費3次修改次數。<br>期間委託預覽會含浮水印，在確認繳清後才會給正式圖。<br>修改次數超過三次後，逐次增加50元。<br>自用委託不可用於任何營利行為。",
  }),
  methods: {
    mob() {
      return this.$vuetify.breakpoint.width > 720;
    },
  },
};
</script>
